
import { Link, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { fileUrl, useFETCH } from "../../Tools/APIs";
import { Col, Row } from "../../Tools/Grid-system";
import { PrintHTML, Promotion } from "../../components";
import Loading from "../../Tools/Loading";
import { content } from "../../Context/translate";

function SingleBlog() {
  const { slug } = useParams();

  const title = slug.replace(/_/g, " ");


  const { data, isLoading } = useFETCH(
    `v1/blog/posts?title=${encodeURIComponent(title)}`
  );

  function replaceSpacesWithUnderscore(str) {
    return str.replace(/ /g, "_");
  }

  if (isLoading) return <Loading />;

  const post = data?.data?.data; 

  return (
    <div>
      <Row className="items-center sm:px-10 relative">
        <Col xs={6}>
          <p className="font-semibold max-sm:text-center text-lg text-Secondary my-3 leading-8 max-sm:font-normal text-gradient max-sm:text-sm">
            {post?.title}
          </p>
        </Col>
        <Col xs={6}>
          <img
            src={fileUrl + post?.image}
            alt=""
            className="mx-auto md:mr-8 h-[300px] max-md:h-[230px] object-contain"
          />
        </Col>
        <Col xs={12}>
          {post?.tags.filter(key => key.type === "keyword").length > 0 && (
            <h4>{content.keywords}</h4>
          )}
          <p className="font-semibold text-lg text-Secondary my-3 leading-8">
            {post?.tags
              ?.filter(key => key.type === "keyword")
              ?.map((keyword, idx) => (
                <span
                  key={idx}
                  className="mr-2 p-2 text-sm border border-sm text-gray-500"
                >
                  {keyword.name}
                </span>
              ))}
          </p>
        </Col>
        <Col xs={12}>
          <p className="font-semibold text-lg text-Secondary my-3 leading-8">
            {post?.author}
          </p>
        </Col>
        <Col xs={12}>
          <p className="font-semibold text-lg text-Secondary my-3 leading-8">
            {post?.category}
          </p>
        </Col>
      </Row>

      <div className="px-2x">
        <PrintHTML text={post?.content} />
      </div>

      <div className="px-2x mt-8">
        {post?.tags.filter(tag => tag.type === "tag").length > 0 && (
          <h4 className="mb-2">{content.tags}</h4>
        )}
        <p className="font-semibold text-lg text-Secondary leading-8">
          {post?.tags
            ?.filter(tag => tag.type === "tag")
            .map((tag, idx) => (
              <Link
                key={idx}
                className="mr-2 text-sm text-gray-500 p-2 shadow-sm border border-gray-200 rounded-sm"
                to={`/blog`}
                state={{ searchSlug: tag.name }}
              >
                {tag.name}
              </Link>
            ))}
        </p>
      </div>

      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        breakpoints={{
          1020: { slidesPerView: 3 },
          767: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        }}
        className="my-5"
      >
        {post?.related_posts?.map((e, i) => (
          <SwiperSlide key={i}>
            <div className="border rounded-lg w-full overflow-hidden">
              <div className="h-[220px] w-full">
                <img
                  src={fileUrl + e.image}
                  alt=""
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="font-semibold md:text-lg text-black my-3 left-7 text-gradient px-2">
                {e.title}
              </p>
              <p className="max-md:text-sm p-2">
                <div className="text-end">
                  <Link
                    to={`/blog/${replaceSpacesWithUnderscore(e.title)}`}
                    state={{ postId: e.id }}
                  >
                    <span className="text-Secondary text-sm font-bold underline mx-2">
                      {content.ReadMore}
                    </span>
                  </Link>
                </div>
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <Promotion />
    </div>
  );
}

export default SingleBlog;
